import { Link } from 'react-router-dom';
import { Icon } from '../../design/Icon';
import { useAppTo } from '../../shell/links';
import type { TreasurySummary, UpcomingEntry } from '../data/types';
import { relativeTime } from '../format';
import { ServiceCard } from './ServiceCard';

/** Trésorerie : module non démarré, solde et dépenses d'exemple. */
export function TreasuryCard({ data }: { data: TreasurySummary }) {
  return (
    <ServiceCard title="Trésorerie" icon="card" preview>
      <p className="hm-eyebrow">{data.period}</p>
      <p className="hm-figure">{data.balance}</p>
      <ul className="hm-lines">
        {data.recent.map((l) => (
          <li key={l.id}>
            <span>{l.label}</span>
            <span className="hm-mono">{l.amount}</span>
          </li>
        ))}
      </ul>
    </ServiceCard>
  );
}

/** À venir : rappels que fournira la Trésorerie, échéances d'exemple. */
export function UpcomingCard({ data, now }: { data: UpcomingEntry[]; now: Date }) {
  return (
    <ServiceCard title="À venir" icon="calendar" preview>
      <ul className="hm-lines">
        {data.map((u) => (
          <li key={u.id}>
            <span>{u.label}</span>
            <span className="hm-mono">{relativeTime(u.at, now)}</span>
          </li>
        ))}
      </ul>
    </ServiceCard>
  );
}

/** Raccourcis : « Nouvelle note » et « Ajouter un mot de passe » sont branchés ; « Inviter un membre » attend son service. */
export function ShortcutsCard() {
  const to = useAppTo();
  return (
    <section className="hm-shortcuts" aria-label="Raccourcis">
      <h2 className="hm-eyebrow">Raccourcis</h2>
      <div className="hm-shortcuts__row">
        <Link to={to('/notes')} state={{ intent: 'new-note' }} className="lh-btn lh-btn-secondary">
          <Icon name="plus" size={18} />
          Nouvelle note
        </Link>
        <Link to={to('/vault')} state={{ intent: 'new-password' }} className="lh-btn lh-btn-tonal">
          <Icon name="vaultkey" size={18} />
          Ajouter un mot de passe
        </Link>
        <button type="button" className="lh-btn lh-btn-tonal" aria-disabled="true" title="Bientôt disponible">
          <Icon name="user" size={18} />
          Inviter un membre
        </button>
      </div>
    </section>
  );
}
